// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a8712085","150":"90e37150","395":"0120110b","472":"964fb992","766":"d78cd6aa"}[chunkId] + ".chunk.js";
};